import React from "react";
import { Switch as AntdSwitch, SwitchProps } from "antd";

interface ViewProps extends SwitchProps {}

export default function View({ ...props }: ViewProps) {
  return <AntdSwitch {...props} />;
}
